import { c as _c } from "react/compiler-runtime";
import { AlertProps, Button, ButtonProps, Loader } from '@mantine/core';
import { UseMutationResult } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { Alert } from '@mantine/core';
type MutationButtonProps = {
  mutation: UseMutationResult<any, any, any, any>;
  children: ReactNode;
  onClick?: () => void;
} & Omit<ButtonProps, 'loading' | 'onClick'>;
export const MutationButton = t0 => {
  const $ = _c(18);
  let children;
  let disabled;
  let mutation;
  let onClick;
  let props;
  if ($[0] !== t0) {
    ({
      mutation,
      children,
      onClick,
      disabled,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = disabled;
    $[3] = mutation;
    $[4] = onClick;
    $[5] = props;
  } else {
    children = $[1];
    disabled = $[2];
    mutation = $[3];
    onClick = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== mutation || $[7] !== onClick) {
    t1 = () => {
      if (onClick) {
        onClick();
      } else {
        mutation.mutate(undefined);
      }
    };
    $[6] = mutation;
    $[7] = onClick;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleClick = t1;
  let t2;
  if ($[9] !== mutation.isPending || $[10] !== props) {
    t2 = mutation.isPending ? <Loader size="sm" /> : props.leftSection;
    $[9] = mutation.isPending;
    $[10] = props;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const t3 = mutation.isPending || disabled;
  let t4;
  if ($[12] !== children || $[13] !== handleClick || $[14] !== props || $[15] !== t2 || $[16] !== t3) {
    t4 = <Button {...props} leftSection={t2} disabled={t3} onClick={handleClick}>{children}</Button>;
    $[12] = children;
    $[13] = handleClick;
    $[14] = props;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};
type MutationErrorProps = {
  mutation: UseMutationResult<any, any, any, any>;
  title: string;
  onClose?: () => void;
} & AlertProps;
export const MutationError = t0 => {
  const $ = _c(10);
  let mutation;
  let onClose;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      mutation,
      title,
      onClose,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = mutation;
    $[2] = onClose;
    $[3] = props;
    $[4] = title;
  } else {
    mutation = $[1];
    onClose = $[2];
    props = $[3];
    title = $[4];
  }
  if (!mutation.isError) {
    return null;
  }
  const t1 = onClose ?? mutation.reset;
  const t2 = mutation.error?.message ?? "An unexpected error occurred";
  let t3;
  if ($[5] !== props || $[6] !== t1 || $[7] !== t2 || $[8] !== title) {
    t3 = <Alert color="red" title={title} onClose={t1} variant="light" {...props}>{t2}</Alert>;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
    $[8] = title;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};